import React, { useState } from 'react';
import { useEffect } from 'react';
import { useContext } from 'react';
import Loader from '../components/loading/Loader';
import Navbar from '../components/navbar/Navbar';
import Sidebar from '../components/sidebar/Sidebar';
import AgbaContext from '../context/agba/agbaContext';
import AboutPage from './about/AboutPage';
import ContactPage from './contact/ContactPage';
import LandingPage from './home/LandingPage';
import ProjectLayoutPage from './project/ProjectLayoutPage';
import { PageDivLayout } from './TagPageStyle';

const PageLayout = () => {
  const agbaContext = useContext(AgbaContext);
  const { sideBar, getProjects } = agbaContext;

  const [spinner, setSpinner] = useState(true);

  useEffect(() => {
    getProjects();

    if (!spinner) {
      setSpinner(false);
    }

    //eslint-disable-next-line
  }, [spinner]);

  const loadTime = (loader) => {
    setSpinner(loader);
  };

  return (
    <>
      {spinner ? (
        <Loader loadTime={loadTime} />
      ) : (
        <>
          <PageDivLayout sideBar={sideBar}>
            <Navbar />
            <Sidebar />
            <LandingPage />
            <ProjectLayoutPage />
            <AboutPage />
            <ContactPage />
          </PageDivLayout>
        </>
      )}
    </>
  );
};

export default PageLayout;
